import React from "react"
import PropTypes from "prop-types"

import FilterContainer from './FilterContainer';
import ProModal from '../app_components/ProModal';
import ProfileTeaser from './ProfileTeaser'
import ConnectAd from './ConnectAd'
import NoMatchesLocation from './no_matches/NoMatchesLocation'

class MatchContainer extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      loading: true,
      userInfoLoaded: false,
      initialMatchesLoaded: false,
      matches: [],
      showFilter: false,
      proModalType: '',
      proModalOpen: false,
      current_user: {},
      pro_settings: null,
      languages_users: [],
      nativeLanguages: [],
      learningLanguages: [],
      premiumUser: false,
      endMatchList: true,
      noMatches: false,
      idVerification: [],
      filterApplied: false,
      filters: {
        gender_id: 1,
        min_age_difference: 18,
        max_age_difference: 152,
        language_ids: [],
        locals_only: '',
        page: 1,
      }
    }

    this.renderMatches = this.renderMatches.bind(this)
    this.toggleProModal = this.toggleProModal.bind(this)
    this.getMatches = this.getMatches.bind(this)
    this.getFilteredMatches = this.getFilteredMatches.bind(this)
    this.updateFilter = this.updateFilter.bind(this)
    this.toggleFilterSection = this.toggleFilterSection.bind(this)
    this.loadMoreMatches = this.loadMoreMatches.bind(this)
    this.updateIdVerification = this.updateIdVerification.bind(this)
    this.updateUserSettings = this.updateUserSettings.bind(this)
    this.noMatchUpdateLocation = this.noMatchUpdateLocation.bind(this)
  }

  loadMoreMatches() {
    let page = this.state.filters.page+1
    this.setState({
      filters: {...this.state.filters, page: page}
    }, () => this.getMatches())
  }

  getMatches() {
    this.setState({
      loading: (this.state.filters.page === 1 ? true : false),
      showFilter: false,
      noMatches: false,
      endMatchList: true,
      initialMatchesLoaded: true
    })
    let data = this.state.filters

    $.ajax({
      url: `../get_filtered_matches`,
      dataType: 'JSON',
      type: 'POST',
      data: data,
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        if(this.state.filters.page === 1) {
          this.setState({
            matches: JSON.parse(data.data.matches),
            loading: false,
            noMatches: JSON.parse(data.data.matches).length === 0,
            endMatchList: JSON.parse(data.data.matches).length < 10
          })
        } else {
          let matches = this.state.matches
          let newMatches = JSON.parse(data.data.matches)
          let matchState = [...matches, ...newMatches]
          this.setState({
            matches: matchState,
            endMatchList: newMatches.length < 10
          })
        }
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  getFilteredMatches() {
    this.setState({
      matches: [],
      showFilter: false,
      filters: {...this.state.filters, page: 1}
    }, () => this.getMatches())
  }

  getCurrentUserInfo() {

    $.ajax({
      url: `../match_current_user`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        let learningLanguages = []
        let nativeLanguages = []
        let language_ids = []
        JSON.parse(data.data.languages_users).map((lu) => {
          if(lu.level === 5) {
            nativeLanguages = [...nativeLanguages, lu]
          } else {
            learningLanguages = [...learningLanguages, lu]
            language_ids = [...language_ids, lu.language_id]
          }
        })
        let filters = {...this.state.filters, language_ids: language_ids}

        this.setState({
          current_user: JSON.parse(data.data.current_user),
          idVerification: JSON.parse(data.data.id_verification),
          pro_settings: JSON.parse(data.data.pro_settings),
          languages_users: JSON.parse(data.data.languages_users),
          nativeLanguages: nativeLanguages,
          learningLanguages: learningLanguages,
          filters: (this.state.filters.locals_only === '' ? {...filters, locals_only: JSON.parse(data.data.current_user).local_chats_only} : filters),
          premiumUser: data.data.premium_user,
          userInfoLoaded: true
        })

      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  componentDidMount() {
    this.getCurrentUserInfo()
  }



  componentDidUpdate() {
    if(!this.state.initialMatchesLoaded && this.state.userInfoLoaded) {
      this.getMatches()
    }
  }

  noMatchUpdateLocation() {
    const filters = {...this.state.filters, [`locals_only`]: false}
    this.setState({
      filters: filters,
      filterApplied: true
    }, () => this.getFilteredMatches())
  }

  updateFilter(filterName, value) {
    const filters = {...this.state.filters, [`${filterName}`]: value}
    this.setState({
      filters: filters,
      filterApplied: true
    })
  }

  updateIdVerification() {
    let data = {
      user: {
        verified_chats_only: !this.state.current_user.verified_chats_only
      }
    }
    $.ajax({
      url: `../update_user`,
      dataType: 'JSON',
      type: 'POST',
      data: data,
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.getCurrentUserInfo()
      },
      catch: (error) => {
        console.log('error')
      }
    })
  }

  updateUserSettings(key, value) {
    let data = {
      user: {
        [key]: value
      }
    }
    $.ajax({
      url: `../update_user`,
      dataType: 'JSON',
      type: 'POST',
      data: data,
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.getCurrentUserInfo()
      },
      catch: (error) => {
        console.log('error')
      }
    })
  }

  renderMatches() {
    if(this.state.noMatches) {
      if(!this.state.filterApplied && this.state.filters.locals_only) {
        //if no matches, and initial load, suggest widening to world wide search
        return(
          <NoMatchesLocation
            noMatchLocationIcon={this.props.noMatchLocationIcon}
            updateFilter={this.noMatchUpdateLocation}
            getMatches={this.getFilteredMatches}
           />)
      }
      return (
        <div style={{textAlign: 'center'}}>
          <h2 className="darkBlue" style={{marginBottom: 15}}>No Matches</h2>
          <h4 className="darkBlue">Adjust your filters to find more matches</h4>
        </div>
      )
    }
    return this.state.matches.map((match, index) => {
      if(index%5 == 4 && !this.state.premiumUser) {
        return(
          <div key={index}>
            <ProfileTeaser
              missingImg={this.props.missingImg}
              mapMarkerIcon={this.props.mapMarkerIcon}
              key={index}
              match={match} />
            <ConnectAd />
          </div>
        )
      }
      return(
        <ProfileTeaser
          missingImg={this.props.missingImg}
          mapMarkerIcon={this.props.mapMarkerIcon}
          key={index}
          match={match} />)
    })
  }
//
  toggleFilterSection() {
    this.setState({
      showFilter: !this.state.showFilter
    })
  }

  toggleProModal(type) {
    this.setState({
      proModalType: type,
      proModalOpen: !this.state.proModalOpen
    })
  }


  render() {

    if(this.state.loading) {
      return (
        <div className="matches_loading_screen">
          <h3 className="darkBlue" style={{textAlign: 'center', paddingTop: 70}}>Loading profiles...</h3>
        </div>)
    }

    return(
      <div style={{backgroundColor: this.state.backgroundColor}}>
        {this.state.proModalOpen && <ProModal
          lexicoin={this.props.lexicoin}
          type={this.state.proModalType}
          onClose={() => this.toggleProModal('')}
          confettiLottie={this.props.confettiLottie}
          />}
        {this.state.showFilter &&
          <FilterContainer
            current_user={this.state.current_user}
            pro_settings={this.state.pro_settings}
            idVerification={this.state.idVerification}
            languages_users={this.state.languages_users}
            premiumUser={this.state.premiumUser}
            toggleProModal={this.toggleProModal}
            toggleFilterSection={this.toggleFilterSection}
            filters={this.state.filters}
            updateFilter={this.updateFilter}
            getMatches={this.getFilteredMatches}
            learningLanguages={this.state.learningLanguages}
            nativeLanguages={this.state.nativeLanguages}
            updateUserSettings={this.updateUserSettings}
            updateIdVerification={this.updateIdVerification}
          />}
        <div style={{textAlign: 'right', padding: 10}}>
          <button className="small_button_primary" onClick={()=> this.toggleFilterSection()}><div style={{display: 'flex', alignItems: 'center'}}><img style={{paddingRight: 5}} src={this.props.filterIcon} />Filter Matches</div></button>
        </div>
        {this.renderMatches()}
        {!this.state.endMatchList &&
          <div style={{textAlign: 'center', marginTop: 20}}>
            <button className="button_secondary" onClick={() => this.loadMoreMatches()}>Load 10 more matches</button></div>}
      </div>
    )
  }

}

export default MatchContainer
